import { COOKIE_TYPES } from '../config';

// JWT Token utilities
export const parseJWT = (token) => {
  if (!token) return null;
  
  try {
    const base64Url = token.split('.')[1];
    const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    const jsonPayload = decodeURIComponent(
      atob(base64)
        .split('')
        .map((c) => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2))
        .join('')
    );
    
    return JSON.parse(jsonPayload);
  } catch (error) {
    console.error('Error parsing JWT token:', error);
    return null;
  }
};

// Get user role from token
export const getUserRole = (token) => {
  const decoded = parseJWT(token);
  if (!decoded || !decoded.userRoleId) return null;
  
  const roleMap = {
    3: 'Admin',
    4: 'DataEntry',
    5: 'exceldata',
    6: 'Client',
    7: 'ReportViewer',
    8: 'UserManagement'
  };
  
  return roleMap[decoded.userRoleId] || null;
};

// LocalStorage utilities
export const setToken = (token) => {
  localStorage.setItem(COOKIE_TYPES.MCHASHID, token);
};

export const getToken = () => {
  return localStorage.getItem(COOKIE_TYPES.MCHASHID);
};

export const removeToken = () => {
  localStorage.removeItem(COOKIE_TYPES.MCHASHID);
};

export const setUser = (user) => {
  localStorage.setItem('currentUser', JSON.stringify(user));
};

export const getUser = () => {
  const user = localStorage.getItem('currentUser');
  return user ? JSON.parse(user) : null;
};

export const removeUser = () => {
  localStorage.removeItem('currentUser');
};

// Check if user is authenticated
export const isAuthenticated = () => {
  const token = getToken();
  if (!token) return false;
  
  const decoded = parseJWT(token);
  if (!decoded) return false;
  
  // Check if token is expired
  const currentTime = Date.now() / 1000;
  return decoded.exp > currentTime;
};

// Logout user
export const logout = () => {
  removeToken();
  removeUser();
  window.location.href = '/login';
};
